<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">THE CECILS</p>
<p class="halfa">THE DYNASTY AND LEGACY OF LORD BURGHLEY</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?794d6250